(function(){
    angular.module('tmx-app').factory('SearchService', ['tmxResource','$q','lookupService','cacheStore', '$mdMedia','TMX_FINANCE_CONSTANTS',
        function(tmxResource,$q,lookupService,cacheStore,$mdMedia,TMX_FINANCE_CONSTANTS){
            var applications = tmxResource("LoanApplication");
            var vm = this;
            vm.tenant= APP_CONSTANTS.tenant;
            vm.BVSVerified = false;
            vm.verifiedCustomer={};
            vm.BVSError="";
            var vitasTenants = ["vitas","vitas-leb","vitas-eg","vitasiraq"];
            vm.fullNameColumnhide = vitasTenants.indexOf(vm.tenant.toLowerCase()) > -1 ? true : false;
            vm.fullNameColumnshow = vitasTenants.indexOf(vm.tenant.toLowerCase()) > -1 ? false : true;
            var transactionStatusLkps = lookupService.getLocalLookupsByType(TMX_FINANCE_CONSTANTS.LOOKUP_TYPES.TransactionStatus).map(x=>({VisibleValue:x.VisibleValue,HiddenValue:x.VisibleValue}));

            applications.lebTranslationModelMapping = {
                "FirstName":"FirstName", "MiddleName":"FatherName","LastName":"LastName", "MotherName":"MotherName","EnglishName":"EnglishName",
                "CdrFirstName":"CDRFirstName","CdrFatherName":"CDRFatherName","CdrFamilyName":"CDRFamilyName","CdrMotherName":"CDRMotherName",
                "MotherFamilyName":"MotherFamilyName","CdrMotherFamilyName":"CDRMotherFamilyName"
            };
            

            applications.lebVmToGuarantorMapping = {
                "FirstName":"TmxPerson.PersonFirstName", "MiddleName":"TmxPerson.PersonMiddleName","LastName":"TmxPerson.PersonLastName", 
                "MotherName":"MotherName","EnglishName":"EnglishName",
                "CdrFirstName":"CdrFirstName","CdrFatherName":"CdrFatherName","CdrFamilyName":"CdrFamilyName","CdrMotherName":"CdrMotherName",
                "MotherFamilyName":"MotherFamilyName","CdrMotherFamilyName":"CdrMotherFamilyName"
            };

            applications.fetchExistingCustomer = function(cnic) {
                return  tmxResource("Integration").getByAction("GetETB/"+cnic, true, 'get');
            }
            applications.fetchCustomerByCNIC = function(cnic) {
                return  tmxResource("CustomerMaster").getByAction("GetByCnic/"+cnic + "/" + "AllData", false, 'get');
            }
            applications.calculateLSA = function(LSAModel) {
                return  tmxResource("CustomerMaster").getByAction("CalculateLSA", false,'post',LSAModel);
            }
            applications.getTabEntityMapping = function() {
                if(cacheStore.get("TabEntityMapping")) {
                    return cacheStore.get("TabEntityMapping");
                }
                else {
                    return  tmxResource("Entity").getByAction("TabEntityMapping/", true, 'get').then(function(response) {
                        cacheStore.set("TabEntityMapping", angular.copy(response.data));
                    });
                }                        
            }

            applications.searchApplicationByNumber = function(applicationNumber) {
                return applications.getByAction("GetApplicationsByApplicationNumber/"+applicationNumber, true,'get').then(function(response) {
                    if(Array.isArray(response.data)) {
                        response.data.forEach(item=>{
                            if(item['TmxCustomerMaster'].length > 0) {
                                item['CustomerName'] = item['TmxCustomerMaster'][0]['CustomerName'];
                                item['CustomerCode'] = item['TmxCustomerMaster'][0]['CustomerCode'] == null?'N/A': item['TmxCustomerMaster'][0]['CustomerCode'];
                            }
                            else {
                                item['CustomerName'] = 'N/A';
                                item['CustomerCode'] = 'N/A';
                            }                                                    
                        })
                        response.AggregateResults = null;
                        response.Data = response.data;
                        response.Errors = null;
                        response.Total = response.data.length;
                        return response;
                    }                               
                });
            }

            applications.searchApplicationbyParams = function(param, ProductId) {
                return applications.getByAction("SearchSecondaryApprovedApps/"+ProductId+"/"+param, true,'get').then(function(response) {
                    if(Array.isArray(response.data)) {
                        response.AggregateResults = null;
                        response.Data = response.data;
                        response.Errors = null;
                        response.Total = response.data.length;
                        return response;
                    }                               
                });
            }

            applications.getExistingApplicationDetails = function(existingApp) {
                return applications.getByAction("GetExistingApplicationDetails", false,'post',existingApp);
            }

            applications.fetchEcib = function(obj) {
                return  tmxResource("Integration").getByAction("GeteCIBData", false, 'post',obj);
            }

            applications.getEligibility = function(obj) {
                return applications.getByAction("getEligibility",false,'post',obj);
            }

            applications.CancelById = function(loanApplicationId) {
                return  applications.getByAction("CancelById/"+loanApplicationId, false, 'put',{});
            }

            applications.getWorkflowStatesByProductId = function (ProductId) {
                return applications.getByAction("WorkflowStates/" + ProductId, true);
            };

            applications.getChecklistHistory = function (applicationId, productChecklistId) {
                return applications.getByAction("GetChecklistHistory/" + applicationId + "/" + productChecklistId, true);
            };
            applications.getGuarantorChecklistHistory = function (guarantorId, productChecklistId) {
                return applications.getByAction("GetGuarantorChecklistHistory/" + guarantorId + "/" + productChecklistId, true);
            };
            applications.getTimeFrames = function(){
             
                return applications.getByAction("GetTimeFrameParameterForReport",false);
            };

            applications.postImage = function(obj){
             
                return applications.getByAction("UploadFile",false,'post',obj);
            };

            applications.reassignApplication = function(array) {
                return applications.getByAction("BulkReassignTask",false,'put',array);
            }

            applications.getloanappjobstatus = function(){
             
                return applications.getByAction("PostLoanApplicationStatus",false);
            };

            applications.getCommandsByProcessId = function(processId){
             
                return applications.getByAction("GetCommandsByProcessId/"+processId,true);
            };

            applications.createLoanApplication = function(data){
             
                return applications.getByAction("",false,'post',data);
            };

            applications.getEcibDetail = function(){
                return tmxResource("enquiry/GeteCIBData").getById("3520268380749",true);

            }

            applications.executeTransactionWF = function(targetController,data){
                return tmxResource(targetController).getByAction("ExecuteWf", false,'put',data);
            }

            applications.getApplicationById = function(id){
                tmxResource("LoanApplication").getById(id).then(function(response){                 
                    return response;
                });
            }

            applications.deleteById = function(id) {
                var deferred = $q.defer();
                tmxResource("LoanApplication").getById(id).then(function(result) {
                    deferred.resolve(result.$remove());
                });
                return deferred.promise;
            };

            applications.setApplicationState = function(data){
                return  tmxResource("LoanApplication").getByAction("SetApplicationState", false, 'put',data);
            }

            var loanAppSearchGridStatus =[] ;
            lookupService.getLoanApplicationStatusLkp().then(function(LoanApplicationStatus){
                LoanApplicationStatus.forEach(function(loanAppStatusLookup) {
                    loanAppSearchGridStatus.push({
                        "HiddenValue":loanAppStatusLookup.HiddenValue,
                        "VisibleValue":loanAppStatusLookup.VisibleValue
                    });
                });
            });

            applications.searchGridColumns = [      
                {
                    field: "Select",
                    title: "Select",
                    type: "text",
                    headerTemplate: "{{'Select' | translate}}",
                    template: "<input type='radio' ng-click='SearchCtrl.applicationSelectChange(dataItem)' id='application' name='application' ng-checked='dataItem.LoanApplicationId == SearchCtrl.selectedApplicationId && SearchCtrl.selectedApplicationId'>",
                },
                {
                    field: "LoanApplicationNumber",
                    title: "LoanApplicationNumber",
                    type: "text",
                    headerTemplate: "{{'LoanApplicationNumber' | translate}}"
                },
                {
                    field: "LoanProductId",
                    title: "LoanProductId",
                    type: "text",
                    headerTemplate: "{{'ProductName' | translate}}",
                    template:"{{SearchCtrl.getProductNameById(dataItem['LoanProductId']) }}",
                },
                {
                    field: "ClientReferenceNumber",
                    title: "ClientReferenceNumber",
                    type: "text",
                    headerTemplate: "{{'Client Reference Number' | translate}}"
                },
                {
                    field: "CustomerName",
                    title: "CustomerName",
                    type: "text",
                    headerTemplate: "{{'CustomerName' | translate}}"
                },
                {
                    field: "CustomerCode",
                    title: "CustomerCode",
                    type: "text",
                    headerTemplate: "{{'CustomerCode' | translate}}"
                },
                {
                    field: "ApplicationStatusLkp",
                    title: "ApplicationStatusLkp",
                    type: "text",
                    template: "{{SearchCtrl.getVisibleValueByLookupId(dataItem.ApplicationStatusLkp)}}",
                    headerTemplate: "{{'Status' | translate}}"
                }
            
            ];

            applications.gridColumns = [
                {
                    field:"LoanApplicationNumber",
                    title: "LoanApplicationNumber",
                    type: "text",
                    search: true,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : SearchCtrl.isFiltered('LoanApplicationNumber')}\" >{{'ApplicationNumber' | translate}}<i class='fa fa-filter' ng-if='SearchCtrl.isFiltered(\"LoanApplicationNumber\")' ></i></span>"
                },
                {
                    field:"FullName",
                    title: "Customer",
                    type: "alpha",
                    search: vm.fullNameColumnhide,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : SearchCtrl.isFiltered('FullName')}\" >{{'Customer' | translate}}<i class='fa fa-filter' ng-if='SearchCtrl.isFiltered(\"FullName\")' ></i></span>",
                    template: "<div>{{dataItem.FullName | defaultValue}} </div> <span class='subtitle-text'>{{dataItem.NationalIdentifierValue | cnic}}</span> ",
                    hidden: vm.fullNameColumnshow,
                    usePattern:false
                },
                {
                    field:"CustomerName",
                    title: "Customer",
                    type: "alpha",
                    search: vm.fullNameColumnshow,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : SearchCtrl.isFiltered('CustomerName')}\" >{{'Customer' | translate}}<i class='fa fa-filter' ng-if='SearchCtrl.isFiltered(\"CustomerName\")' ></i></span>",
                    template: "<div>{{dataItem.CustomerName | defaultValue}} </div> <span class='subtitle-text'>{{dataItem.NationalIdentifierValue | cnic}}</span>",
                    hidden: vm.fullNameColumnhide,
                    usePattern:false
                },
                {
                    field:"NationalIdentifierValue",
                    title: "Cnic",
                    type: "numeric",
                    search: true,
                    hidden:true,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : SearchCtrl.isFiltered('NationalIdentifierValue')}\" >{{'Cnic' | translate}}<i class='fa fa-filter' ng-if='SearchCtrl.isFiltered(\"NationalIdentifierValue\")' ></i></span>",
                    template: "<span class='nowrap'>{{dataItem.NationalIdentifierValue | cnic}}</span>"

                },
                {
                    field:"ProductName",
                    title:"Product",
                    type:"text",
                    search: true,
                    template: "<span title='{{dataItem.ProductName}}'>{{ dataItem.ProductName}}</span>",
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : SearchCtrl.isFiltered('ProductName')}\" >{{'Product' | translate}}<i class='fa fa-filter' ng-if='SearchCtrl.isFiltered(\"ProductName\")' ></i></span>"
                },
                {
                    field:"BranchName",
                    title:"Branch ",
                    type:"text",
                    search: true,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : SearchCtrl.isFiltered('BranchName')}\" >{{'Branch' | translate}}<i class='fa fa-filter' ng-if='SearchCtrl.isFiltered(\"BranchName\")' ></i></span>"
                },
                {
                    field:"CreatorName",
                    title:"Creator",
                    type: "text",
                    search: true,
                    width: $mdMedia('gt-sm')?'10%':'50px',  
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : SearchCtrl.isFiltered('CreatorName')}\" >{{'Creator' | translate}}<i class='fa fa-filter' ng-if='SearchCtrl.isFiltered(\"CreatorName\")' ></i></span>",
                    template:"<div>{{dataItem.CreatorName}}</div><span class='subtitle-wrap '>{{ dataItem.Creator }}</span>",   
                },
                {
                    field:"InboxName",
                    title:"Assigned To",
                    type: "text",
                    search: true,
                    width: $mdMedia('gt-sm')?'10%':'50px',  
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : SearchCtrl.isFiltered('InboxName')}\" >{{'InboxUser' | translate}}<i class='fa fa-filter' ng-if='SearchCtrl.isFiltered(\"InboxName\")' ></i></span>",
                    template:"<div>{{dataItem.InboxName}}</div><span class='subtitle-wrap '>{{ dataItem.InboxUser }}</span><br><span ng-if='dataItem.InboxName!=null' class='subtitle-wrap'><b>{{ dataItem.TransitionTime }}</b></span>",                  
                },            
                {
                    field:"LoanApplicationDate",
                    title:"AppDate",
                    type: "date",
                    search: true,
                    template: "<span >{{dataItem.FormattedLoanApplicationDate}}</span>",
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : SearchCtrl.isFiltered('LoanApplicationDate')}\" >{{'AppDate' | translate}}<i class='fa fa-filter' ng-if='SearchCtrl.isFiltered(\"LoanApplicationDate\")' ></i></span>"
                }, //
                {
                    field:"Status",
                    title:"Status",
                    type: "text",
                    search: true,
                    hidden:true,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : SearchCtrl.isFiltered('ApplicationStatusLkp')}\" >{{'Status' | translate}}<i class='fa fa-filter' ng-if='SearchCtrl.isFiltered(\"ApplicationStatusLkp\")' ></i></span>"
                },
                {
                    template: "<md-menu flex='none' class='menu-list-item' md-position-mode=\"target-right target\" md-offset='-20 60'>"
                                    +"<md-button class='menu-list-item-grid'  ng-click='$mdOpenMenu()' ><md-icon class='menu-list-item material-icons'>more_vert</md-icon></md-button>"
                                        +"<md-menu-content width='2' >"
                                            +"<md-menu-item><md-button ng-disabled='SearchCtrl.deleteEntityPermission' aria-label='del' class='tmxMin'  ng-click='SearchCtrl.clickDelete(dataItem)'> <md-icon class='md-accent material-icons menu-list-item'>delete</md-icon>Cancel</md-button></md-menu-item>"
                                            +"<md-menu-item><md-button ng-disabled='SearchCtrl.assignEntityPermission' aria-label='del' class='tmxMin'  ng-click='SearchCtrl.clickAssign(dataItem)'> <md-icon class='md-accent material-icons menu-list-item'>assignment</md-icon>Assign</md-button></md-menu-item>"
                                        +"</md-menu-content>"
                                +"</md-menu>",
                }
            ];

            applications.cols = [

                {
                    field:"LoanApplicationNumber",
                    title: "ApplicationNumber",
                    type: "text",
                    search: true,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : SearchCtrl.isFiltered('LoanApplicationNumber')}\" >{{'ApplicationNumber' | translate}}<i class='fa fa-filter' ng-if='SearchCtrl.isFiltered(\"LoanApplicationNumber\")' ></i></span>"
    
                },
                {
                    field:"FullName",
                    title: "CustomerName",
                    type: "alpha",
                    search: vitasTenants.indexOf(vm.tenant.toLowerCase()) > -1?true:false,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : SearchCtrl.isFiltered('FullName')}\" >{{'CustomerName' | translate}}<i class='fa fa-filter' ng-if='SearchCtrl.isFiltered(\"FullName\")' ></i></span>",
                    hidden: vitasTenants.indexOf(vm.tenant.toLowerCase()) > -1?false:true,
                    usePattern:false
                },
                {
                    field:"CustomerName",
                    title: "CustomerName",
                    type: "alpha",
                    search: vitasTenants.indexOf(vm.tenant.toLowerCase()) > -1?false:true,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : SearchCtrl.isFiltered('CustomerName')}\" >{{'CustomerName' | translate}}<i class='fa fa-filter' ng-if='SearchCtrl.isFiltered(\"CustomerName\")' ></i></span>",
                    hidden: vitasTenants.indexOf(vm.tenant.toLowerCase()) > -1?true:false,
                    usePattern:false
                
                },
                {
                    field:"NationalIdentifierValue",
                    title: "Cnic",
                    type: "numeric",
                    search: true,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : SearchCtrl.isFiltered('NationalIdentifierValue')}\" >{{'Cnic' | translate}}<i class='fa fa-filter' ng-if='SearchCtrl.isFiltered(\"NationalIdentifierValue\")' ></i></span>",
                    template: "{{dataItem.NationalIdentifierValue}} "
    
    
                },
                {
                    field:"ProductName",
                    title:"Product",
                    type: "text",
                    search: true,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : SearchCtrl.isFiltered('ProductName')}\" >{{'Product' | translate}}<i class='fa fa-filter' ng-if='SearchCtrl.isFiltered(\"ProductName\")' ></i></span>"
    
                },            
                {
                    field:"BranchName",
                    title:"LoanBranch ",
                    type:"text",
                    search: true,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : SearchCtrl.isFiltered('BranchName')}\" >{{'LoanBranch' | translate}}<i class='fa fa-filter' ng-if='SearchCtrl.isFiltered(\"BranchName\")' ></i></span>"
                },
                {
                    field:"Creator",
                    title:"Creator",
                    type: "text",
                    search: true,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : SearchCtrl.isFiltered('Creator')}\" >{{'Creator' | translate}}<i class='fa fa-filter' ng-if='SearchCtrl.isFiltered(\"Creator\")' ></i></span>"
                },
                {
                    field:"InboxUser",
                    title:"InboxUser",
                    type: "text",
                    search: true,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : SearchCtrl.isFiltered('InboxUser')}\" >{{'InboxUser' | translate}}<i class='fa fa-filter' ng-if='SearchCtrl.isFiltered(\"InboxUser\")' ></i></span>"
                },            
                {
                    field:"LoanApplicationDate",
                    title:"AppDate",
                    type: "date",
                    search: true,
                    applySearchRangeForThisDate:true,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active':SearchCtrl.isFiltered('LoanApplicationDate')}\" >{{'AppDate' | translate}}<i class='fa fa-filter' ng-if='SearchCtrl.isFiltered(\"LoanApplicationDate\")' ></i></span>"
                },
                {
                    field:"Status",
                    title:"Status",
                    type: "text",                
                    isNumber: true,
                    headerTemplate:"<span  ng-class=\"{ 'filter-active' : SearchCtrl.isFiltered('Status')}\" >{{'Status' | translate}}<i class='fa fa-filter' ng-if='SearchCtrl.isFiltered(\"Status\")' ></i></span>"
                }
            ];

            return applications;

        }]);

       
})();